import type { Clock } from 'ProdantixSdk/core/types';

export const systemClock: Clock = {
  now: () => new Date(),
};

export function isoTimestamp(date: Date): string {
  return date.toISOString();
}
